export default {
  campaigns: [],
  currentMonth: {},
  selectedModes: [],
  isMariaSelected: false,
}
